import React, { useState } from 'react';
import { SafeForm } from '../SafeForm';
import { Share2, Check, Loader2, X } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const ShareDesign = ({ session }) => {
  const [open, setOpen] = useState(false);
  const [toEmail, setToEmail] = useState('');
  const [fromName, setFromName] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [sentTo, setSentTo] = useState('');

  const submit = async () => {
    setBusy(true); setError('');
    try {
      const r = await fetch(`${API}/api/visualizer/sessions/${session.id}/share`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ toEmail, fromName, message }) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.detail || 'Versturen mislukt'); }
      setSentTo(toEmail); setToEmail(''); setMessage('');
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => { setOpen(true); setSentTo(''); }} className="inline-flex items-center gap-2 text-sm font-semibold text-[#3a190b] border border-[#3a190b]/25 hover:bg-[#3a190b]/5 px-4 py-2 rounded-full transition-colors" data-testid="share-design-btn">
        <Share2 className="h-4 w-4" />{sentTo ? 'Nog iemand laten meekijken' : 'Deel met partner of familie'}
      </button>
    );
  }
  return (
    <SafeForm onValidSubmit={submit} className="rounded-xl border border-[#3a190b]/15 bg-white p-4 space-y-3" data-testid="share-design-form">
      <div className="flex items-start justify-between gap-3">
        <p className="text-sm font-semibold text-[#202020] flex items-center gap-2"><Share2 className="h-4 w-4 text-[#3a190b]" />Laat iemand meekijken</p>
        <button type="button" onClick={() => setOpen(false)} className="text-[#202020]/50 hover:text-[#202020]" aria-label="Sluiten" data-testid="share-design-close"><X className="h-4 w-4" /></button>
      </div>
      {sentTo && <p className="flex items-center gap-2 text-sm text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2" data-testid="share-design-sent"><Check className="h-4 w-4" />Verstuurd naar {sentTo}.</p>}
      <div className="flex flex-col sm:flex-row gap-2">
        <input type="text" value={fromName} onChange={(e) => setFromName(e.target.value)} placeholder="Uw voornaam" className="sm:w-40 rounded-lg border border-[#3a190b]/20 px-3 py-2 text-sm" data-testid="share-from-name" />
        <input type="email" required value={toEmail} onChange={(e) => setToEmail(e.target.value)} placeholder="E-mail van partner of familielid" className="flex-1 rounded-lg border border-[#3a190b]/20 px-3 py-2 text-sm" data-testid="share-to-email" />
      </div>
      <textarea value={message} onChange={(e) => setMessage(e.target.value)} maxLength={400} rows={2} placeholder="Persoonlijk bericht (optioneel) — bv. 'Wat vind jij van deze tegels?'" className="w-full rounded-lg border border-[#3a190b]/20 px-3 py-2 text-sm" data-testid="share-message" />
      {error && <p className="text-xs text-red-600" data-testid="share-design-error">{error}</p>}
      <button type="button" data-submit="true" disabled={busy} className="inline-flex items-center justify-center gap-2 bg-[#3a190b] hover:bg-[#500000] text-white px-5 py-2.5 rounded-full text-sm font-semibold disabled:opacity-60" data-testid="share-design-submit">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Share2 className="h-4 w-4" />}Verstuur ontwerp
      </button>
    </SafeForm>
  );
};

export default ShareDesign;
